import { Link } from "react-router-dom";
import { hotTags } from "../../mocks/manga";

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-sparkling-2-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-display text-2xl text-foreground-950">妖精漫画网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              妖精漫画网致力于打造好用的漫画阅读收藏入口，把阅读、收藏、下载、书单、标签与目录整理整合在一起，让每一位读者都能把喜欢的作品统一管理，找漫追更更省心。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-qq-line", "ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  aria-label="联系妖精漫画网"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-700"
                >
                  <i className={`${icon} text-base`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="站内导航">
            <h4 className="mb-4 text-sm font-bold text-foreground-950">快速入口</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li><Link className="transition-colors hover:text-primary-700" to="/">首页</Link></li>
              <li><Link className="transition-colors hover:text-primary-700" to="/library">漫画大全</Link></li>
              <li><Link className="transition-colors hover:text-primary-700" to="/booklists">精选书单</Link></li>
              <li><Link className="transition-colors hover:text-primary-700" to="/about">关于我们</Link></li>
            </ul>
          </nav>

          <nav aria-label="热门标签">
            <h4 className="mb-4 text-sm font-bold text-foreground-950">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {hotTags.slice(0, 10).map((tag) => (
                <Link
                  key={tag}
                  to={`/library?tag=${encodeURIComponent(tag)}`}
                  className="rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-600 transition-colors hover:bg-accent-200 hover:text-foreground-900"
                >
                  #{tag}
                </Link>
              ))}
            </div>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 妖精漫画网 版权所有 · 漫画阅读 · 收藏 · 书单 · 标签整理
          </p>
          <p className="text-xs text-foreground-500">让每一部好作品，都被认真收藏。</p>
        </div>
      </div>
    </footer>
  );
}